import Input from "../components/Input";
import Label from "../components/Label";

function ContractRejected() {
    return (
        <div>
            <div className="content mt-5">
                <div className="container">
                    <div className="card p-5">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="">
                                    <div className="">
                                        <div className="row">
                                            <div className="col-lg-5">
                                                <img src="../../dist/img/my-aegon-santander.png" alt="AdminLTE Logo" className="brand-image" style={{ opacity: '.8', width: 270 }} />
                                            </div>
                                            <div className="col-lg-7">
                                                <div className="row mt-5">
                                                    <div className="col-sm-12 mb-2">
                                                        <h1 className="m-0 form-header">Bedankt voor uw terugkoppeling</h1>
                                                    </div>
                                                    <div className="pr-5">
                                                        <div className="col-sm-12 mb-2">
                                                        Wij gaan dit valideren en komen bij u terug.


                                                        </div>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ContractRejected;